import { render, staticRenderFns } from "./reviewers.vue?vue&type=template&id=197edf16&scoped=true&"
import script from "./reviewers.vue?vue&type=script&lang=js&"
export * from "./reviewers.vue?vue&type=script&lang=js&"
import style0 from "./reviewers.vue?vue&type=style&index=0&id=197edf16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197edf16",
  null
  
)

export default component.exports